import React from 'react';
import { Tabs } from 'antd';
import GeneralTab from './components/GeneralTab';

const { TabPane } = Tabs;
const ContactPerson = () => {
    return (
        <Tabs defaultActiveKey="1">
            <TabPane tab="Contact Person" key="1">
                <GeneralTab />
            </TabPane>
        </Tabs>
    )
}

export default ContactPerson;

